module.exports = __webpack_public_path__ + "static/media/landing-flower.499efac3.svg";